const PROVIDERS = {
  godaddy: ["GoDaddy", (z) => `https://dcc.godaddy.com/control/dnsmanagement?domainName=${z}`],
  namecheap: ["Namecheap", (z) => `https://ap.www.namecheap.com/Domains/DomainControlPanel/${z}/advancedns`],
  cloudflare: ["Cloudflare", () => "https://dash.cloudflare.com/"],
  hostinger: ["Hostinger", (z) => `https://hpanel.hostinger.com/domain/${z}/dns`],
  squarespace: ["Squarespace", () => "https://account.squarespace.com/domains"],
  route53: ["AWS Route 53", () => "https://console.aws.amazon.com/route53/v2/hostedzones"],
  wix: ["Wix", () => "https://manage.wix.com/account/domains"],
  porkbun: ["Porkbun", () => "https://porkbun.com/account/domainsSpeedy"],
  namecom: ["Name.com", (z) => `https://www.name.com/account/domain/details/${z}#dns`],
  ionos: ["IONOS", () => "https://my.ionos.com/domains"],
  bigrock: ["BigRock", () => "https://manage.bigrock.in/"],
  digitalocean: ["DigitalOcean", () => "https://cloud.digitalocean.com/networking/domains"],
  vercel: ["Vercel", () => "https://vercel.com/dashboard/domains"],
};

export const dnsProvider = (id, zone) => {
  const p = PROVIDERS[id];
  return p ? { name: p[0], url: p[1](zone) } : null;
};

export const ago = (iso) => {
  if (!iso) return "never";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  return h < 24 ? `${h} h ago` : `${Math.round(h / 24)} d ago`;
};

export const RECORD_LABEL = { a: "A record", cname: "CNAME", txt: "TXT" };
